import { Component, OnInit, ViewChild } from '@angular/core';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-organisation-customer',
    templateUrl: './organisation-customer.component.html',
    styleUrls: ['./organisation-customer.component.scss'],
    providers: [OrganisationCustomerService],
    standalone: false
})
export class OrganisationCustomerComponent implements OnInit {

  @ViewChild(DataTableComponent) table: DataTableComponent;

  public title = 'Organisation Customers';
  public pageActions: PageAction[];

  public columns = [
    { prop: 'organisationName' },
    { prop: 'priceModel' },
    { prop: 'name.firstName', name: 'firstname' },
    { prop: 'name.lastName', name: 'lastname' }
  ];

  public searchColumns = [{ prop: 'organisationName' }, { prop: 'priceModel' }, { prop: 'name.firstName', name: 'firstname' }, { prop: 'name.lastName', name: 'lastname' }];

  constructor(
    public organisationCustomerService: OrganisationCustomerService,
    public dialogService: DialogService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.createPageAction();
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['organisation-customers', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['organisation-customers', event.row._id, 'edit']);
  }

  private createPageAction() {
    this.pageActions = [
      new PageAction({
        icon: 'create_new_folder',
        title: 'Create customer',
        callback: () => {
          this.router.navigate(['organisation-customers', 'create']);
        }
      })
    ]
  }

  public onRemove(event: DataTableEvent) {
    this.dialogService.confirm('Remove organisation customer?').then(res => {
      if (!res) {
        return;
      }
      return this.organisationCustomerService.remove(event.row._id).then(() => {
        this.table.refresh();
      }).catch(error => {
        const message = (error.error.message ? error.error.message : error.message);
        return this.dialogService.confirm(message, error.name);
      });
    });
  }
}

